import { getUrlParam } from "./scroll-card";
import get from "lodash/get";
import canUseDOM from "./can-use-dom";

export function scrollInViewCard(
  props = {},
  card,
  options = {
    block: "start"
  }
) {
  const elementId = get(props, ["card", "id"], -1);
  if (canUseDOM && card && elementId === getUrlParam(window.location.href, "cardId")) {
    card.scrollIntoView(options);
  }
}
